module.exports = __webpack_public_path__ + "img/box_img1.c67f4042.png";